/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TwoFactorDisableResult } from '../../models/two-factor-disable-result';
import { TwoFactorVerifyRequest } from '../../models/two-factor-verify-request';

export interface Disable$Params {
      body: TwoFactorVerifyRequest
}

export function disable(http: HttpClient, rootUrl: string, params: Disable$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFactorDisableResult>> {
  const rb = new RequestBuilder(rootUrl, disable.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TwoFactorDisableResult>;
    })
  );
}

disable.PATH = '/auth/2fa/disable';
